module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Zoom plus-943166ae35e6733ef2ba150e5d92eeab.svg";